import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import useIsxlAndUp from '../../../hooks/useIsXlAndUp';
import useScrollCompensation from '../../../hooks/useScrollCompensation';
import { HEADER } from '../../sizeConstants';
import { passSx, sxPropType, useDefaultComponentValue } from '../../utils';
const COMPONENT_NAME = 'Clientbar';
const Clientbar = /*#__PURE__*/ React.forwardRef((inProps, ref)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, sx, isDrawerOpen = false, ...other } = props;
    const scrollSx = useScrollCompensation();
    const isXlAndUp = useIsxlAndUp();
    return /*#__PURE__*/ React.createElement(Paper, {
        ref: ref,
        elevation: 5,
        sx: [
            (theme)=>({
                    borderRadius: '0',
                    flexShrink: 0,
                    height: 'auto',
                    position: 'fixed',
                    top: HEADER.MOBILE_HEIGHT,
                    width: 1,
                    [theme.breakpoints.up('md')]: {
                        top: HEADER.DASHBOARD_DESKTOP_HEIGHT
                    },
                    zIndex: isDrawerOpen && !isXlAndUp ? theme.zIndex.drawer - 1 : theme.zIndex.drawer + 1
                }),
            scrollSx,
            ...passSx(sx)
        ],
        ...other
    }, children);
});
Clientbar.displayName = COMPONENT_NAME;
Clientbar.propTypes = {
    children: PropTypes.node,
    sx: sxPropType,
    isDrawerOpen: PropTypes.bool
};
export default Clientbar;
